import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { IntlProvider } from "react-intl";
import AppLocale from "./lang";
import { getDirection } from "./helpers/Utils";
import { ModalTimeOut } from "./components/Alert/ModalAlert";

import {
  getAuth,
  getUser,
  getCompanyprofile,
  getRole,
  countryAddress,
  provinceAddress,
  getUserEmail,
  getCompanyPkindev,
} from "./redux/actions";
import SpinnerLoading from "./components/Loading/SpinnerLoading";
import BillingNote from "./views/BillingNote";
import BillingProject from "./views/BillingProject/BillingProject";
import Subscription from "./views/Subscription/Subscription";
import SubscriptionPage from "./views/SubscriptionProjectV2";
import TestSubscription from "./views/Subscription/TestSubscription";

const ViewMain = React.lazy(() =>
  import(/* webpackChunkName: "views" */ "./views")
);
const ViewAdmin = React.lazy(() => import("./views/Home"));
const ViewError = React.lazy(() => import("./views/error"));
const ViewLogin = React.lazy(() => import("./views/login"));
const ViewCreateNewPassword = React.lazy(() =>
  import("./views/createNewPassword")
);

class App extends Component {
  constructor(props) {
    super(props);
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add("rtl");
      document.body.classList.remove("ltr");
    } else {
      document.body.classList.add("ltr");
      document.body.classList.remove("rtl");
    }

    this.state = {
      modal_timeout: false,
    };
  }

  componentDidMount() {
    this.props.getUserEmail();
    if (this.props.auth_user.length !== 0) {
      this.props.getUser(this.props.auth_user[0].id_bill);
      this.props.getCompanyprofile({
        id_bill: this.props.auth_user[0].id_bill,
      });
      this.props.getRole(this.props.auth_user[0].id_bill);
      this.props.countryAddress();
      this.props.provinceAddress("en");
      this.props.getCompanyPkindev({
        id_bill: this.props.auth_user[0].id_bill,
      });

      // if (typeof localStorage.getItem("expAt") != "undefined") {
      //   const time = new Date().getTime();
      //   if (Math.floor(time / 1000) >= localStorage.getItem("expAt")) {
      //     localStorage.clear();
      //     window.location.href = "/";
      //   }
      // }

      // ดึงค่าจาก localStorage (ได้เป็น string หรือ null)
      const expAt = localStorage.getItem("expAt");

      if (expAt) {
        // คำนวณเวลา ณ ปัจจุบันเป็นวินาที
        const nowInSeconds = Math.floor(Date.now() / 1000);

        // แปลง expAt เป็นตัวเลข แล้วเปรียบเทียบ
        if (nowInSeconds >= Number(expAt)) {
          localStorage.clear();
          window.location.href = "/";
        }
      }

      this.setCheckTokenEXP();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.auth_user.length !== this.props.auth_user.length) {
      this.props.getUser(this.props.auth_user[0].id_bill);
      this.props.getCompanyprofile({
        id_bill: this.props.auth_user[0].id_bill,
      });
      this.props.getRole(this.props.auth_user[0].id_bill);
      this.props.countryAddress();
      this.props.provinceAddress("en");
      this.setCheckTokenEXP();
    }
  }

  setCheckTokenEXP = () => {
    let looptimeout = setInterval(() => {
      const time = new Date().getTime();
      if (Math.floor(time / 1000) >= localStorage.getItem("expAt")) {
        clearInterval(looptimeout);
        this.setState({
          modal_timeout: !this.state.modal_timeout,
        });
      }
    }, 1000);
  };

  render() {
    const { locale } = this.props;
    const currentAppLocale = AppLocale[locale];

    return (
      <>
        <div className="h-100">
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <React.Fragment>
              <Suspense fallback={<SpinnerLoading modal={false} />}>
                <Router>
                  <Switch>
                    {/* ── หน้าสาธารณะ ต้องมาก่อน guard ──

                        Switch เลือก route แรกที่ match แล้วหยุด ส่วน
                        <Redirect to="/login" /> ใน guard ไม่มี path จึง match
                        ทุก URL — ถ้า guard อยู่ก่อน หน้าพวกนี้จะถูกเด้งไป login
                        ทั้งที่ไม่ต้องใช้บัญชี (เคยทำให้ /subscription เข้าไม่ได้)

                        /subscription  หน้าสมัครใช้บริการ
                        /project/...   ลิงก์ใบแจ้งหนี้ที่ส่งให้ลูกค้าเปิดเอง */}

                    <Route
                      path="/verify/:id"
                      render={(props) => <ViewLogin {...props} />}
                    />
                    <Route
                      path="/create_new_password/:id"
                      render={(props) => <ViewCreateNewPassword {...props} />}
                    />
                    
                    <Route
                      path="/subscription"
                      render={(props) => <SubscriptionPage {...props} />}
                    />

                    <Route
                      path="/project/:id_project/:id_invoice"
                      render={(props) => <BillingProject {...props} />}
                    />


                    {/* ── พื้นที่ที่ต้อง login ──
                        เงื่อนไขเดียว: มี auth_user และ status ผ่าน

                        ⚠️ ทั้งสองกิ่งต้องมี path="/Home" เสมอ
                           ไม่งั้นตอนไม่ได้ login URL /Home/Dashboard จะหลุด
                           ไปเข้า <Route path="/:id_company/:id_invoice">
                           (Home = id_company, Dashboard = id_invoice)
                           แล้ว BillingNote โหลดใบที่ไม่มี → 404 → หน้าขาว */}
                    {this.props.auth_user?.length !== 0 &&
                    this.props.auth_user[0]?.status ? (
                      <Route
                        path="/Home"
                        render={(props) => <ViewAdmin {...props} />}
                      />
                    ) : (
                      <Route path="/Home" render={() => <Redirect to="/login" />} />
                    )}

                    {/* ⚠️ ต้องเด้งเองเมื่อ login แล้ว
                        เดิมโครงเป็น ternary — พอ login สำเร็จ route นี้จะหาย
                        จาก Switch แล้ว URL /login ตกไป <Route path="/"> ซึ่ง
                        พาเข้า /Home ต่อ ตอนนี้ route อยู่ถาวรจึงต้องเช็คเอง
                        ไม่งั้นกด login สำเร็จแล้วยังค้างหน้าเดิม */}
                    <Route
                      path="/login"
                      render={(props) =>
                        this.props.auth_user?.length !== 0 &&
                        this.props.auth_user[0]?.status ? (
                          // ⚠️ ต้องเป็น path เต็ม — views/Home/index.js ไม่มี
                          //    redirect จาก /Home เปล่าๆ ไป Dashboard
                          //    (บรรทัดนั้นถูก comment ทิ้ง) ถ้าเด้งมาแค่ /Home
                          //    จะไม่ match route ไหนเลยแล้วตกไป /error
                          <Redirect to="/Home/Dashboard" />
                        ) : (
                          <ViewLogin {...props} />
                        )
                      }
                    />

                    {/* ⚠️ ต้องอยู่ท้ายสุด — pattern 2 ส่วนจับได้กว้างมาก
                        ถ้าอยู่ก่อน route อื่น "/login" ก็จะเข้าเงื่อนไขนี้ */}
                    <Route
                      path="/:id_company/:id_invoice"
                      render={(props) => <BillingNote {...props} />}
                    />

                    <Route
                      path="/error"
                      exact
                      render={(props) => <ViewError {...props} />}
                    />
                    <Route
                      path="/"
                      render={(props) => <ViewMain {...props} />}
                    />
                    {/* <Redirect to="/error" /> */}
                  </Switch>
                </Router>
              </Suspense>
            </React.Fragment>
          </IntlProvider>
        </div>
        <ModalTimeOut
          show={this.state.modal_timeout}
          saveData={() => {
            localStorage.clear();
            window.location.href = "/login";
          }}
        />
      </>
    );
  }
}

const mapStateToProps = ({ auth, settings }) => {
  const { locale, loading } = settings;
  const { auth_user } = auth;
  return { auth_user, locale, loading };
};
const mapActionsToProps = {
  getAuth,
  getUser,
  getCompanyprofile,
  getRole,
  countryAddress,
  provinceAddress,
  getUserEmail,
  getCompanyPkindev,
};

export default connect(mapStateToProps, mapActionsToProps)(App);